<m-popper v-if="!isSidebarUsed"
          ref="popper"
          :id="id"
          class="m-popup"
          :class="{ 'm--is-inline': $slots.trigger }"
          :class-name="className"
          :open.sync="popperOpen"
          :disabled="disabled"
          :placement="placement"
          :focus-management="focusManagement"
          :open-trigger="propOpenTrigger"
          :trigger="propTrigger"
          :lazy="lazy"
          :before-enter="beforeEnter"
          :enter="enter"
          :after-enter="afterEnter"
          :enter-cancelled="enterCancelled"
          :before-leave="beforeLeave"
          :leave="leave"
          :after-leave="afterLeave"
          :leave-cancelled="leaveCancelled"
          :shadow="shadow"
          :padding="padding"
          :padding-header="paddingHeader"
          :padding-body="paddingBody"
          :padding-footer="paddingFooter"
          :preload="preload"
          :width="width"
          :background="background"
          :close-on-click-outside="closeOnBackdrop"
          :reference="reference"
          @open="emitOpen"
          @close="emitClose"
          @portal-mounted="emitPortalMounted"
          @portal-after-open="emitPortalAfterOpen"
          @portal-after-close="emitPortalAfterClose"
          @click-outside="emitClickOutside"
          @after-enter="emitAfterEnter">
    <div v-if="$slots.trigger"
         slot="trigger">
        <slot name="trigger" />
    </div>
    <slot name="header"
          slot="header" />
    <slot />
    <slot name="footer"
          slot="footer" />
</m-popper>
<m-sidebar v-else-if="isSidebarUsed"
           ref="sidebar"
           :id="id"
           class="m-popup"
           :class="{ 'm--is-inline': $slots.trigger }"
           :class-name="className"
           :open.sync="sideBarOpen"
           :disabled="disabled"
           :focus-management="focusManagement"
           :initial-focus-element="initialFocusElement"
           :close-on-backdrop="closeOnBackdrop"
           :preload="preload"
           :lazy="lazy"
           :trigger="propTrigger"
           :padding="padding"
           :padding-header="paddingHeader"
           :padding-body="paddingBody"
           :padding-footer="paddingFooter"
           :open-trigger="propOpenTrigger"
           :full-height="sidebarFullHeight"
           @open="emitOpen"
           @close="emitClose"
           @portal-mounted="emitPortalMounted"
           @portal-after-open="emitPortalAfterOpen"
           @portal-after-close="emitPortalAfterClose"
           @after-enter="emitAfterEnter">
    <div v-if="$slots.trigger"
         slot="trigger">
        <slot name="trigger" />
    </div>
    <slot name="header"
          slot="header" />
    <slot />
    <slot name="footer"
          slot="footer" />
</m-sidebar>
